import { SIGNIN, SIGNOUT } from '../types/auth';
import { getLocalData, storeLocalData } from '../../helpers/localStore';
import { AUTH } from '../../constants';

let initialState = { ok: false };

const auth = getLocalData(AUTH);

if (auth) {
  initialState = auth;
}

export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SIGNIN:
      storeLocalData(AUTH, payload);
      return {
        ...payload,
      };
    case SIGNOUT:
      localStorage.clear();
      return {
        ok: false,
      };
    default:
      return state;
  }
}
